import React from 'react';

export default function LegalDocument({ sections }) {
  if (!sections || sections.length === 0) {
    return null;
  }

  return (
    <div className="legal-document">
      {sections.map((section) => (
        <section key={section.title} className="legal-document-section">
          <h3>{section.title}</h3>
          {(section.paragraphs || []).map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          {section.listPrefix && <p>{section.listPrefix}</p>}
          {section.list && section.list.length > 0 && (
            <ul>
              {section.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
          {(section.paragraphsAfterList || []).map((paragraph, index) => (
            <p key={`after-${index}`}>{paragraph}</p>
          ))}
        </section>
      ))}
    </div>
  );
}
